module.exports = __webpack_public_path__ + "static/media/about1.09cb3ed3.jpg";